// extracted by mini-css-extract-plugin
export default {"video":"videoPreview__video--G94vi"};